import { inject, Injectable } from '@angular/core';
import { DefaultTranspiler, TranspileParams } from '@jsverse/transloco';
import { EnvironmentService } from '@services/utils/environment.service';

const BRAND_DICTIONARY_KEY = 'BRAND';

// Fills {{brand}} in translation strings with the current build's brand, spelled as the active language's BRAND dictionary says
@Injectable()
export class BrandTranspiler extends DefaultTranspiler {
  private readonly brandKey = `${BRAND_DICTIONARY_KEY}.${inject(EnvironmentService).currentBuild.toUpperCase()}`;

  override transpile(transpileParams: TranspileParams): unknown {
    const { value, params, translation } = transpileParams;

    // Object params are child paths, not interpolation params: string leaves reached through them and array items come back here
    if (typeof value !== 'string') {
      return super.transpile(transpileParams);
    }

    return super.transpile({ ...transpileParams, params: { brand: translation[this.brandKey], ...params } });
  }
}
